import { LabelWithDescription } from '@/components/LabelWithdescription';
import { OverViewCardInfo } from '../OverviewCardInfo';
import { RefetchOptions } from '@tanstack/react-query';
import { MODAL_IDS } from 'src/enums/EModal';
import { CallResponseConfigForm } from './CallResponseConfigForm';
import { Card, Switch } from 'antd';
import { formatTextWithHighlightedVariables } from '@/utils/textFormatting';

export const CallResponseConfigInfo: React.FC<{
	data: any;
	refetch: (options?: RefetchOptions) => Promise<any>;
}> = ({ data, refetch }) => {
	const voiceMailMessage = data?.voicemailMessage;
	const is_amd_enabled = data?.is_amd_enabled;

	const callResponseConfig = {
		is_amd_enabled,
		voicemail_template: voiceMailMessage,
	};

	const InfoComponent = () => {
		if (!callResponseConfig) {
			return null;
		}

		return (
			<Card className="mt-4 mb-4">
				<div>
					<LabelWithDescription
						customClassName="mt-2"
						label="Smart Call Detection"
						description="Automatically detects if a human or voicemail system answered the call."
					/>
					<Switch checked={callResponseConfig.is_amd_enabled} disabled className="mt-2 mb-4" />
				</div>

				<div>
					<LabelWithDescription
						customClassName="mt-2 mb-2"
						label="Voicemail Message"
						description="Spoken when an answering machine is detected."
					/>
					<span
						className="w-9/12 mt-1 pt-2 pb-4"
						dangerouslySetInnerHTML={{
							__html: formatTextWithHighlightedVariables(callResponseConfig.voicemail_template),
						}}
					/>
				</div>
			</Card>
		);
	};

	return (
		<OverViewCardInfo
			info={<InfoComponent />}
			form={<CallResponseConfigForm callResponseConfig={callResponseConfig} refetch={refetch} />}
			formActionType="Edit"
			width={'80%'}
			footer={null}
			modalId={MODAL_IDS.CALL_RESPONSE_CONFIG_FORM_MODAL}
		/>
	);
};
